<script>
  import { getStyleValue, generateSocialIcon } from "../../Common/tools";
  import ImageHeader from "./ImageHeader.svelte";
  import TextEditor from "../../Common/TextEditor.svelte";
  import Unsubscribe from "./Unsubscribe.svelte";
  import {External} from "../../external";

  export let data, meta, globalStyle, onChange;

  function change(prop, val) {
    onChange();
    data = Object.assign({}, data, { [prop]: val });
  }
</script>

<tr>
  <th class="column has-columns" style="padding-left: 40px; padding-right: 40px;" width={getStyleValue(globalStyle.width, 600)}>
    <table class="row" cellspacing="0" cellpadding="0">
      <tbody>
        {#if !data.hideLogo}
          <tr>
            <ImageHeader data={data} globalStyle={globalStyle} isChild={true} style="padding-left: 0; text-align: left;" />
            <th class="column" width="365"></th>
          </tr>
          <tr>
            <td class="spacer" colspan="2" style="font-size: 30px; line-height: 30px;" height="30">&nbsp;</td>
          </tr>
        {/if}
        <tr style="vertical-align: top;" valign="top">
          <th class="column" style="padding-right: 10px; color: #969AA1; font-weight: 400; text-align: left;" width="365">
            <TextEditor bind:data={data.content} meta={meta} onChange={(val) => change("content", val)} emailEditor={true} />
          </th>
          <th class="column mobile-text-left" style="padding-left: 10px;" width="365">
            <table class="mobile-left" cellspacing="0" cellpadding="10" align="right">
              <tbody>
                <tr>
                  {#each data.menu as item, i (item)}
                    {#if item.link}
                      <td style="padding-left: 5px;">
                        <a style="background-color: rgba(255,255,255,.1); width:30px; height: 30px; line-height: 30px; display: inline-block;border-radius: 50%;">
                          <img src={generateSocialIcon(data, i)} alt="" style="vertical-align: middle;width:15px;height:15px; padding: 8px;" />
                        </a>
                      </td>
                    {/if}
                  {/each}
                </tr>
              </tbody>
            </table>
          </th>
        </tr>
      </tbody>
    </table>

    <table class="row divider" width="100%" cellspacing="0" cellpadding="0">
      <tbody>
        <tr>
          <th height="61">
            <div style="border-top: 1px solid #2B2E32; font-size: 0; line-height: 0;">&nbsp;</div>
          </th>
        </tr>
      </tbody>
    </table>

    <table class="row" cellspacing="0" cellpadding="0">
      <tbody>
        <tr>
          <th class="column" style="color: {data.style.brandColor}; font-weight: 400; text-align: left;" width="475">
            {#if External.Website.emailMarketingSettings.companyName || External.Website.emailMarketingSettings.companyAddress}
              <span>
                {#if External.Website.emailMarketingSettings.companyName}{External.Website.emailMarketingSettings.companyName} | {/if}
                {#if External.Website.emailMarketingSettings.companyAddress}{External.Website.emailMarketingSettings.companyAddress} | {/if}
              </span>
            {/if}
            <Unsubscribe data={data} globalStyle={globalStyle} isChild={true} style="display: inline-block;" />
          </th>
        </tr>
      </tbody>
    </table>
  </th>
</tr>
